import React from "react";
import styled, { css } from "styled-components";
import { Button, Divider } from "antd";
import { useFieldArray } from "react-hook-form";
import TSimpleRadio from "components/form/Field/TSimpleRadio";
import { TInput } from "components/form/Field/TInput";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

function HotStampingRadio(props) {
  const { control, setValue, errors, trigger, watch, getValues } = props;
  const { fields, remove, append } = useFieldArray({
    control,
    name: "cover.hot_stamping",
  });

  return (
    <HotStampingContainer>
      <CustomPlainDivider orientation="left" plain>
        Hot Stamping
      </CustomPlainDivider>
      <CustomLinkButton
        onClick={() => append({ color: "" })}
        className="button"
        icon={<PlusOutlined />}
        disabled={fields.length > 2}
      >
        Add Hot Stamping
      </CustomLinkButton>
      {fields.map((item, index) => {
        return (
          <div key={item.id} className="field">
            <div className="container">
              <h2 className="title">Hot Stamping {index + 1}</h2>
              <div className="radio">
                <TSimpleRadio
                  options={["Gold", "Silver", "Other"]}
                  defaultValue={item.color}
                  control={control}
                  name={`cover.hot_stamping[${index}].color`}
                  errors={errors}
                  trigger={trigger}
                  setValue={setValue}
                  className="input"
                  size="small"
                />
                {watch(`cover.hot_stamping[${index}].color`) !== "Gold" &&
                  watch(`cover.hot_stamping[${index}].color`) !== "Silver" && (
                    <TInput
                      errors={errors}
                      name={`cover.hot_stamping[${index}].color`}
                      placeholder="Insert color here"
                      defaultValue={item.color}
                      size="small"
                      propsInput={{
                        control: control,
                      }}
                      noMb
                    />
                  )}
              </div>
            </div>

            <Button
              type="dashed"
              danger
              icon={<DeleteOutlined />}
              size="medium"
              onClick={() => remove(index)}
            />
          </div>
        );
      })}
    </HotStampingContainer>
  );
}

const HotStampingContainer = styled.div`
  margin-top: ${(props) => props.theme.spacing[4]};
  display: flex;
  flex-direction: column;

  .button {
    margin-top: ${(props) => props.theme.spacing[1]};
  }

  .field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${(props) => props.theme.spacing[2]};
    border: 2px solid ${(props) => props.theme.colors.grey[200]};
    //background-color: ${(props) => props.theme.colors.grey[100]};
    padding: ${(props) => props.theme.spacing[2]};

    .container {
      display: flex;
      flex-direction: column;
    }

    .title {
      font-size: ${(props) => props.theme.fontSize["sm"]};
      color: ${(props) => props.theme.colors.grey[700]};
    }

    .radio {
      display: flex;
      align-items: center;

      .input {
        margin-right: ${(props) => props.theme.spacing[2]};
      }
    }
  }
`;

export const CustomPlainDivider = styled(Divider)`
  .ant-divider-inner-text {
    color: ${(props) => props.theme.colors.grey[700]};
    font-weight: 600;
  }

  ::before {
    border-top: 1px solid ${(props) => props.theme.colors.grey[200]} !important;
  }

  ::after {
    border-top: 1px solid ${(props) => props.theme.colors.grey[200]} !important;
  }
`;

export const CustomLinkButton = styled(Button)`
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  border-radius: 3px;
  color: ${(props) => props.theme.colors.grey[600]};
  font-weight: 500;
  transition: all 0.7s;
  &&& {
    margin-top: 0;
  }
  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `};

  ${(props) =>
    props.mb &&
    css`
      margin-bottom: ${(props) => props.theme.spacing[2]};
    `};

  :hover,
  :active,
  :focus {
    color: ${(props) => props.theme.colors.grey[600]};
    border-color: ${(props) => props.theme.colors.grey[400]};
  }
`;

export default HotStampingRadio;
